import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import VueResource from 'vue-resource'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
// import BootstrapVue from "bootstrap-vue";
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";

import { library } from '@fortawesome/fontawesome-svg-core'
import { dom } from '@fortawesome/fontawesome-svg-core'
import icons from './assets/js/fontawesome'

library.add( icons );
dom.watch()
// import { FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
// Vue.component('font-awesome-icon', FontAwesomeIcon)
// Vue.use(BootstrapVue);

// Sentry 
Sentry.init({
  Vue,
  dsn: "https://bc1f14964f1342c2b192c6ec9fd93280@o951137.ingest.sentry.io/4504598542286848",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", "staging.api.icrobotics.com", "api.icrobotics.com"],
    }),
    new Sentry.Integrations.Breadcrumbs({
      console: false
    })
  ],
  tracesSampleRate: 1.0,
});

import Quill from 'quill'
import SentenceBlot from '@/components/blots/SentenceBlot.js'
import VariableBlot from '@/components/blots/VariableBlot.js'
import SynonymBlot from '@/components/blots/SynonymBlot.js'
import GlobalSynonymBlot from '@/components/blots/GlobalSynonymBlot.js'
import MethodBlot from '@/components/blots/MethodBlot.js'
import StylingBlot from '@/components/blots/StylingBlot.js'
import LinkBlot from '@/components/blots/LinkBlot.js'
Quill.register(SentenceBlot, true)
Quill.register(MethodBlot, true)
Quill.register(SynonymBlot, true)
Quill.register(GlobalSynonymBlot, true)
Quill.register(VariableBlot, true)
Quill.register(StylingBlot, true)
// Quill.register(LinkBlot, true)


import SentenceList from '@/components/SentenceList'
import ConditionList from '@/components/ConditionList'
import Bullet from '@/components/Bullet.vue'
import Dropdown from '@/components/Dropdown'
import CustomInput from '@/components/CustomInput'
Vue.component('sentenceList', SentenceList)
Vue.component('conditionList', ConditionList)
Vue.component('bullet', Bullet) 
Vue.component('dropdown', Dropdown)
Vue.component('customInput', CustomInput)

import appHelper from '@/assets/js/appHelper'
import VariableHelpers from '@/assets/js/variableHelpers.js'
import VModal from 'vue-js-modal'
// import Vuebar from 'vuebar'
// Vue.use(Vuebar)
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true, scrollable: true} })

Vue.use(VueResource)
Vue.http.options.root = store.state.apiUrl
// Vue.http.headers.common['Authorization'] = 'Bearer Zv_BYYIdxVkCmuNJCmMKCquCRjOB-h-v0tLqneCqnja7r3rjWurlQXQ90XD9wfh1YB24IIr2B3IPTtCigp10NcOdqsWhr0b_eRTT-OKfwIFqIS-qZnvDjiKvpE-GD3apHtAbLQxdH5_W_oKsEM8yVXAxQE-D34h8AGYChtu7x32L2130tmpjzf5J0NaKdEDbPwTrF-1HPQfbYERfyncBsbDcDoj1_1fqn4rJqbBKygBmIgu5gtE3b5NvwjO37TIjdC7Axuy1zY_p-ebaiH1LZlQNAGgaqXiHyTkO5NlL3yRu6jpXQYFC2ZVo_4x8M6YCtE38eDHnZIsEbG1_CT1RxQKJw-jeIpF-sD3QuiSrgmrvStY34q9NOQjTmOElTfmM';
Vue.http.interceptors.push(function(request, next) {
  if (request.url != 'login' && !appHelper.isSignup(request) && !["reset-password", "forgot-password" , "demo", "demo.signup"].includes(router.currentRoute.name ) ) {
    request.headers.set('Authorization', 'Bearer ' + store.state.token.access_token)
  }
  if( !["demo/create","demo/checkurl"].includes(request.url)  && ["demo", "demo.signup"].includes( router.currentRoute.name ) ) {
    const demoKey = request.url == "demo/template" ? store.state.temporaryDemoKey : store.state.demoData.metadata.demoKey
    request.headers.set('X-Demo-Key', demoKey )
  }
  request.headers.set('X-Language', store.getters.language)

  next(response => {
    if (response.status == 401) { 
      if(router.currentRoute.name && router.currentRoute.name.includes("demo")) return
      else if(router.currentRoute.name == "template") store.dispatch('handleExpiredToken')
      else store.dispatch('logOut').then(() => router.push('login'))
    }
  })
});

// Vue.http.options.root = 'http://localhost:54237/'
// Vue.http.headers.common['Authorization'] = 'Bearer kMd9I00O2o4Fnx2-GyzqA8fV9AEgiGcgiQO9o8RPPuZCQ9n4c0N8v9ip2Q45RkYJd8fMCN1Ljizz8YsvLoLWkNvY7pPn80FeWoLC2Q0pjhe6g1lCWYP1wqR2iISneQF6yZbp7BQx3IfZQ1Kv08hajsqLrTs3KXEH9wOohpcE1s6dC10QhRDTc_FGQigRO8WGGbcx1e8Pgt-rE-ksmJUdR8IO7WXJu79LXiwkMe4q0jfwnrPZOh-mDA51R9MU6dqsf8xnugY7CKvEOVsH3E8ffJA8BBs3za2mXCw4bVr1GyJn1laXHnk72VTVBX0uFtF3LhPo6jMGwcvpLnQeTl2uRqtr7WsudtERd3WN8HwgIYKEEKPRu_irxFkBT3YyWpX9'

Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
  store.state.loadingRoute = true
  
  if(process.env.NODE_ENV != "development" && window.location.origin.toLowerCase().includes("demo") && !to.name.includes("demo") ){
    next("/demo/signup")
  }

  else if (store.state.token && !["demo", "demo.signup"].includes(to.name)) {
    await store.dispatch('getUser')
    next()
  }
  else if (to.name !== 'login' && !["signup", "reset-password", "forgot-password", "demo", "demo.signup"].includes(to.name) ) next('/login')
  else next()

  // if(store.state.planExpired && to.name !== 'login' && to.name !== 'signup' && to.name !== 'reset-password' && to.name !== 'forgot-password' && to.name !== 'settings.subscription'){
  // // if(from.name != "settings.subscription" && store.state.planExpired || from.name == null && store.state.planExpired ){
  //   // next('/settings')
  //   console.log(to.name)
  //   store.dispatch('handleExpiredPlan')
  // }
})
router.afterEach((to, from, next) => {
  store.state.loadingRoute = false
})

import VueFilterDateFormat from 'vue-filter-date-format';
import i18n from './i18n'

Vue.use(VueFilterDateFormat)
Vue.filter('removeVariableFormatting', VariableHelpers.removeFormatting)
Vue.filter('conditionOperator', operator => ({or: i18n.t('operators.or'), and: i18n.t('operators.and') }[operator]))
Vue.filter('variable', (text, variables, toGet = 'displayName') => { // toGet is either displayName or value
  if (text == null) return text
  let vars = text.match(/{.*?\}/g)
  if (vars) vars.forEach(v => {
    // let variable = VariableHelpers.getByName(v, variables)
    if (toGet === 'displayName') text = text.replace(new RegExp(v, 'g'), '<span class="variable">' + VariableHelpers.getPrettyName(v, variables) + '</span>')
    if (toGet === 'value') text = text.replace(new RegExp(v, 'g'), '<span class="variable">' + VariableHelpers.getPrettyName(v, variables) + '</span>')
  })
  return text
})
Vue.filter('capitalize', (text) => text ? text.charAt(0).toUpperCase() + text.slice(1) : '')


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
